import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Workspace } from '../../../core/models/workspace.model';
import { getWorkspaceLabel } from '../../../core/utils/workspace.utils';

/**
 * Tarjeta de un workspace, compartida por el selector posterior al login (`mode="default"`,
 * con botón Entrar y marca de reciente) y por el modal de cambio de workspace
 * (`mode="switch"`, una lista compacta con selección única).
 */
@Component({
  selector: 'app-workspace-option',
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  templateUrl: './workspace-option.html',
  styleUrl: './workspace-option.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceOption {
  workspace = input.required<Workspace>();
  mode = input<'default' | 'switch'>('default');
  selected = input<boolean>(false);
  /** El workspace en el que está trabajando la sesión ahora mismo. */
  active = input<boolean>(false);

  selectWorkspace = output<Workspace>();

  protected label = computed<string>(() => getWorkspaceLabel(this.workspace()));
  protected isSwitchMode = computed<boolean>(() => this.mode() === 'switch');

  /** Inicial para los workspaces que no tienen logo cargado. */
  protected initial = computed<string>(() => this.label().trim().charAt(0).toUpperCase() || 'W');

  protected roleLabel = computed<string>(() => {
    const role = this.workspace().role
      ?.trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');

    if (role === 'administrator' || role === 'administrador' || role === 'admin') return 'Administrador';
    if (role === 'standard' || role === 'estandar') return 'Estándar';
    return 'Miembro';
  });

  protected onSelect(): void {
    this.selectWorkspace.emit(this.workspace());
  }

  // Un logo cuyo archivo ya no está en el host de medios dejaría un hueco roto en la
  // tarjeta; ocultarlo devuelve el sitio a la inicial del fondo.
  protected onLogoError(event: Event): void {
    (event.target as HTMLImageElement).style.display = 'none';
  }
}
